

export class PosHistory {
        // Note: Using only optional constructor properties without backing store disables typescript's type checking for the type

        constructor(id?: string, deploymentRequestId?: string, bankId?: string, bankName?: string, merchant?: string, idMerchant?: string,
                outlet?: string, district?: string, address?: string, contactPerson?: string, contactNo?: string, idTerminal?: string,
                terminalType?: string, currency?: string, tipAdjustment?: boolean, manualTransaction?: boolean, preAuthorization?: boolean, depDate?: string,
                primaryNacNumber?: string, secondaryNacNumber?: string, priority?: boolean, statusId?: number, statusName?: string, todayEntered?: string,
                remarks?: string, requestName?: string, refund?: boolean, applicationVersionId?: string, applicationVersion?: string, todayDeployed?: string,
                totalReconfigured?: string, totalRetrieve?: string, deployedby?: string, branchName?: string, component1?: string, component2?: string, combineValue?: string, finalValue?: string, kvc1?: string, kvc2?: string,
                applicationDate?: Date, serialNumber?: string, serialKey?: string, image?: string, latitude?: string, longitude?: string,
                merchantLocation?: string, receivedBy?: string, remarksDeploy?: string, scanned?: string, createdBy?: string, applicationDateVersion?: string,
                createdDate?: Date, connectivity?: string, deployDate?: Date, primaryItem?: string, secondaryItem?: string, tertiaryItem?: string, detailItem?: string, isReceived?: string, verifiedBy?: string, verifiedDate?: Date, item?: string, applicationFormat?: string,
                receivedContactNo?: string, serialNumberId?: string, previousSerial?: string, configStatus?: string, isSold?: string, province?: string, merchantCategory?: string, isSupportPresent?: boolean,pannumber?: string, connectivities?: Array<number>) {
                this.id = id!;
                this.bankId = bankId!;
                this.bankName = bankName!;
                this.merchant = merchant!;
                this.idMerchant = idMerchant!;
                this.outlet = outlet!;
                this.district = district!;
                this.address = address!;
                this.contactPerson = contactPerson!;
                this.contactNo = contactNo!;
                this.idTerminal = idTerminal!;
                this.terminalType = terminalType!;
                this.currency = currency!;
                this.tipAdjustment = tipAdjustment!;
                this.manualTransaction = manualTransaction!;
                this.preAuthorization = preAuthorization!;
                this.primaryNacNumber = primaryNacNumber!;
                this.secondaryNacNumber = secondaryNacNumber!;
                this.priority = priority!;
                this.statusId = statusId!;
                this.statusName = statusName!;
                this.remarks = remarks!;
                this.depDate = depDate!;
                this.requestName = requestName!;
                this.refund = refund!;
                this.applicationVersionId = applicationVersionId!;
                this.applicationVersion = applicationVersion!;
                this.applicationDate = applicationDate!;
                this.serialNumberId = serialNumberId!;
                this.serialNumber = serialNumber!;
                this.serialKey = serialKey!;
                this.deployDate = deployDate!;
                this.image = image!;
                this.primaryItem = primaryItem!;
                this.secondaryItem = secondaryItem!;
                this.tertiaryItem = tertiaryItem!;
                this.detailItem = detailItem!;
                this.isReceived = isReceived!;
                this.verifiedBy = verifiedBy!;
                this.verifiedDate = verifiedDate!;
                this.item = item!;
                this.component1 = component1!;
                this.component2 = component2!;
                this.kvc1 = kvc1!;
                this.kvc2 = kvc2!;
                this.combineValue = combineValue!;
                this.finalValue = finalValue!;
                this.applicationFormat = applicationFormat!;
                this.applicationDateVersion = applicationDateVersion!
                this.receivedContactNo = receivedContactNo!;
                this.latitude = latitude!;
                this.longitude = longitude!;
                this.merchantLocation = merchantLocation!;
                this.receivedBy = receivedBy!;
                this.remarksDeploy = remarksDeploy!;
                this.scanned = scanned!;
                this.previousSerial = previousSerial!;
                this.configStatus = configStatus!;
                this.deployedby = deployedby!;
                this.isSold = isSold!;
                this.province = province!;
                this.todayEntered = todayEntered!;
                this.todayDeployed = todayDeployed!;
                this.totalReconfigured = totalReconfigured!;
                this.totalRetrieve = totalRetrieve!;
                this.merchantCategory = merchantCategory!;
                this.branchName = branchName!;
                this.createdBy=createdBy!;
                this.createdDate=createdDate!;
                this.connectivity=connectivity!;
                this.isSupportPresent = isSupportPresent!;
                this.connectivities = connectivities!;
                this.pannumber = pannumber!;
        }

        public id: string;
        public deploymentRequestId!: string
        public branchName: string
        public bankId: string;
        public depDate: string;
        public bankName: string;
        public merchant: string;
        public idMerchant: string;
        public outlet: string;
        public district: string;
        public address: string;
        public deployedby: string;
        public contactPerson: string;
        public contactNo: string;
        public idTerminal: string;
        public terminalType: string;
        public currency: string;
        public tipAdjustment: boolean;
        public manualTransaction: boolean;
        public preAuthorization: boolean;
        public primaryNacNumber: string;
        public secondaryNacNumber: string;
        public priority: boolean;
        public statusId: number;
        public statusName: string;
        public remarks: string;
        public requestName: string;

        public todayEntered: string;
        public todayDeployed: string;
        public totalReconfigured: string;
        public totalRetrieve: string;


        public refund: boolean;
        public applicationVersionId: string;
        public applicationVersion: string
        public applicationDate: Date;
        public serialNumberId: string;
        public serialNumber: string;
        public serialKey: string;
        public image: string;
        public latitude: string;
        public longitude: string;
        public merchantLocation: string;
        public receivedBy: string;
        public remarksDeploy: string;
        public scanned: string;
        public createdBy: string;
        public createdDate: Date;
        public deployDate: Date;
        public connectivity: string;
        public primaryItem: string;
        public secondaryItem: string;
        public tertiaryItem: string;
        public detailItem: string;
        public isReceived: string;
        public verifiedBy: string;
        public verifiedDate: Date;
        public item: string;
        public applicationFormat: string;
        public applicationDateVersion: string;
        public receivedContactNo: string;
        public previousSerial: string;
        public configStatus: string;
        public isSold: string;

        public province: string;
        public merchantCategory: string;
        public component1: string;
        public component2: string;
        public combineValue: string;
        public finalValue: string;
        public kvc1: string;
        public kvc2: string;
        public isSupportPresent: boolean;
        public connectivities: Array<number>;
        public pannumber: string;


}



